import { FBInputType } from '../FBInput/FBInput.types';
import { FBSchemaProps } from './FBSchema.types';

const isStepType = (item: FBSchemaProps, stepTypes: FBInputType[]): boolean => (
  item.type !== undefined && stepTypes.includes(item.type)
);

export const getSchemaControlKey = ({ type, name, index }: FBSchemaProps): string => (
  type === 'mpiprocedure' ? `fb-control-${type}-${String(name)}` : `fb-control-${String(type)}-${String(name)}-${String(index)}`
);

export const normalizeSchema = (
  schema: FBSchemaProps[],
  stepTypes: FBInputType[],
): FBSchemaProps[] => {
  let stepIndex = 0;
  return schema.map((item, index) => {
    const isStep = isStepType(item, stepTypes);
    if (isStep && !item.deleted) { stepIndex++; }
    if (item.index === index && (!isStep || item.stepIndex === stepIndex)) { return item; }
    return { ...item, index, ...(isStep && { stepIndex }) };
  });
};

export const replaceSchemaItem = (
  schema: FBSchemaProps[],
  item: FBSchemaProps,
  index: number,
  stepTypes: FBInputType[],
): FBSchemaProps[] => {
  const next = schema.slice();
  next[index] = item;
  // Initial schemas can have absent/stale metadata on other fields. Repair it
  // in one pass while retaining references for already-normalized siblings.
  return normalizeSchema(next, stepTypes);
};

export const isSchemaItemVisible = (
  item: FBSchemaProps,
  currentTabId?: string,
  leftPanelOpen = false,
): boolean => {
  const { deleted = false, hidden = false, tabId = '' } = item;

  if (deleted || hidden) {
    return false;
  }

  const isOnCurrentTab = !tabId
    || currentTabId === undefined
    || tabId.toLowerCase() === currentTabId.toLowerCase();

  return isOnCurrentTab || leftPanelOpen;
};

export const getSchemaRenderMetadata = (
  schema: FBSchemaProps[],
  stepTypes: FBInputType[],
  isApprovalBlocking: (item: FBSchemaProps) => boolean,
): Array<{ stepIndex?: number, isBlocked: boolean }> => {
  let stepIndex = 0;
  let isBlocked = false;
  return schema.map((item) => {
    const isStep = isStepType(item, stepTypes);
    if (isStep && !item.deleted) { stepIndex++; }
    const metadata = { stepIndex: isStep ? stepIndex : undefined, isBlocked };
    // Even hidden/deleted approval fields were considered by the prior reverse
    // lookup. An approval only controls the fields that follow it.
    if (item.type === 'requestapproval' || item.type === 'inlineapproval') {
      isBlocked = isApprovalBlocking(item);
    }
    return metadata;
  });
};
